/* eslint-disable react/prop-types */
import React, { useEffect, useRef } from "react";
import Portal from "./Portal";
import styled from "styled-components";
import { Label, Input, Validator, FormField } from "@churchofjesuschrist/eden-form-parts";
import Modal from "@churchofjesuschrist/eden-platform-modal";
import Row from "@churchofjesuschrist/eden-row";
import { Primary as PrimaryButton, Secondary as SecondaryButton } from "@churchofjesuschrist/eden-buttons";
import Stack from "@churchofjesuschrist/eden-stack";
import { spacing32, breakWidth480 } from "@churchofjesuschrist/eden-style-constants";
import { mediaBreak480w } from "@churchofjesuschrist/eden-styled-helpers";

const determineValidityState = validityState => {
  const valid = validityState.valid;
  return valid === true ? "success" : valid === false ? "error" : "unknown";
};

const ModalBody = styled.div.withConfig({
  componentId: "sc-1yor4e4-0"
})(["padding:", ";width:100%;", ";"], spacing32, mediaBreak480w`
    min-width: ${breakWidth480};
  `);

const ImagePrompt = _ref => {
  let {
    url,
    onUrlChange,
    description,
    onDescriptionChange,
    onConfirm,
    onCancel,
    strings
  } = _ref;
  const urlRef = useRef(null);
  useEffect(() => {
    setTimeout(() => {
      var _urlRef$current;

      urlRef === null || urlRef === void 0 ? void 0 : (_urlRef$current = urlRef.current) === null || _urlRef$current === void 0 ? void 0 : _urlRef$current.focus();
    }, 0);
  }, []);
  return /*#__PURE__*/React.createElement(Portal, null, /*#__PURE__*/React.createElement(Modal, {
    active: true,
    onCloseGesture: onCancel,
    type: "normal"
  }, /*#__PURE__*/React.createElement(ModalBody, null, /*#__PURE__*/React.createElement(Validator, null, _ref2 => {
    let {
      checkValidity,
      validity
    } = _ref2;
    return /*#__PURE__*/React.createElement("form", {
      noValidate: true,
      onSubmit: event => {
        event.preventDefault();

        if (checkValidity(event) === true) {
          onConfirm();
        }
      }
    }, /*#__PURE__*/React.createElement(Stack, {
      gapSize: "32"
    }, /*#__PURE__*/React.createElement(FormField, {
      validityState: determineValidityState(validity.url)
    }, /*#__PURE__*/React.createElement(Label, null, strings.url, /*#__PURE__*/React.createElement(Input, {
      ref: urlRef,
      name: "url",
      type: "text",
      value: url,
      placeholder: "https://www.churchofjesuschrist.org/1.png",
      onChange: event => onUrlChange(event.target.value),
      required: true,
      pattern: "(http(s?):)([/|.|\\w|\\s|-])*\\.(?:jpg|gif|png)"
    }))), /*#__PURE__*/React.createElement(FormField, {
      validityState: determineValidityState(validity.description)
    }, /*#__PURE__*/React.createElement(Label, null, strings.description, /*#__PURE__*/React.createElement(Input, {
      name: "description",
      type: "text",
      value: description,
      placeholder: "",
      onChange: event => onDescriptionChange(event.target.value),
      required: true
    }))), /*#__PURE__*/React.createElement(Row, {
      gapSize: "16"
    }, /*#__PURE__*/React.createElement(PrimaryButton, {
      type: "submit"
    }, strings.confirm), /*#__PURE__*/React.createElement(SecondaryButton, {
      onClick: onCancel
    }, strings.cancel))));
  }))));
};

export default ImagePrompt;